<div class="button" (click)="handleClick()">
    <div class="button-placeholder">{{ label }}</div>
</div>